var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 1.48148C19.9993 0.663282 19.336 0 18.5178 0H5.3682C4.55 0 3.88672 0.663282 3.88672 1.48148V5.79133C5.07572 5.25784 6.38695 4.94985 7.77596 4.94985C12.982 4.94985 17.2213 9.14623 17.2213 14.2996C17.2213 14.8661 17.1602 15.4105 17.0657 15.9495H18.5178C19.336 15.9495 19.9993 15.2862 19.9993 14.468V1.48148Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77849 22.0001C12.0744 22.0001 15.557 18.5528 15.557 14.3004C15.557 10.0479 12.0744 6.60059 7.77849 6.60059C3.48255 6.60059 0 10.0479 0 14.3004C0 18.5528 3.48255 22.0001 7.77849 22.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeMedium);
export default __webpack_public_path__ + "static/media/shape-medium.4bff00b04fbb180bf7c69684d254cf1a.svg";
export { ForwardRef as ReactComponent };